var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEosLogo = function SvgEosLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.2 50"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6 0 4.9 16.1 0 39.9 16.6 50l16.6-10.1-5-23.9ZM2.7 38.8l3.7-18.1 8.4 25.5Zm4.9-22.2 9-12.4 9 12.4-9 27.2Zm10.7 29.6 8.4-25.5 3.7 18.1Z",
    "data-name": "Layer 1"
  }))));
};
export default SvgEosLogo;